/* Sticker border — angular offset technique */
(function(){
window._groupedContour=function(img,cutOffset,opts){
  try{
    var oW=img.naturalWidth||img.width,oH=img.naturalHeight||img.height;
    if(!oW||!oH)return null;
    /* Downscale for processing if image is large */
    var maxP=800,sc=1;
    if(Math.max(oW,oH)>maxP){sc=maxP/Math.max(oW,oH);}
    var pW=Math.round(oW*sc),pH=Math.round(oH*sc);
    var pOff=Math.max(1,Math.round(cutOffset*sc));
    var srcCv=document.createElement('canvas');srcCv.width=pW;srcCv.height=pH;
    var srcCx=srcCv.getContext('2d');srcCx.drawImage(img,0,0,pW,pH);
    var td=srcCx.getImageData(0,0,pW,pH).data;
    var tp=0;for(var i=3;i<td.length;i+=4)if(td[i]<240)tp++;
    if(tp<10)return null;
    var pad=pOff+4;
    var cw=pW+pad*2,ch=pH+pad*2;
    var cv=document.createElement('canvas');cv.width=cw;cv.height=ch;
    var cx=cv.getContext('2d');
    /* Angular offset border — all radii */
    var samples=36;
    for(var r=pOff;r>=1;r-=1){
      for(var i=0;i<samples;i++){
        var angle=i*(2*Math.PI/samples);
        cx.drawImage(srcCv,pad+Math.cos(angle)*r,pad+Math.sin(angle)*r);
      }
    }
    cx.drawImage(srcCv,pad,pad);
    /* Recolor to white */
    cx.globalCompositeOperation='source-in';
    cx.fillStyle='#ffffff';
    cx.fillRect(0,0,cw,ch);
    /* Flood fill internal holes only */
    var fillData=cx.getImageData(0,0,cw,ch);
    var fd=fillData.data;
    var bg=new Uint8Array(cw*ch),fq=[],fqi=0;
    for(var x=0;x<cw;x++){if(fd[x*4+3]<128){bg[x]=1;fq.push(x);}var bi=(ch-1)*cw+x;if(fd[bi*4+3]<128){bg[bi]=1;fq.push(bi);}}
    for(var y=1;y<ch-1;y++){if(fd[(y*cw)*4+3]<128){bg[y*cw]=1;fq.push(y*cw);}var ri=y*cw+cw-1;if(fd[ri*4+3]<128){bg[ri]=1;fq.push(ri);}}
    while(fqi<fq.length){var idx=fq[fqi++],ix=idx%cw,iy=(idx-ix)/cw;for(var dy=-1;dy<=1;dy++)for(var dx=-1;dx<=1;dx++){var nx=ix+dx,ny=iy+dy;if(nx>=0&&nx<cw&&ny>=0&&ny<ch){var ni=ny*cw+nx;if(!bg[ni]&&fd[ni*4+3]<128){bg[ni]=1;fq.push(ni);}}}}
    for(var i=0;i<cw*ch;i++){if(!bg[i]&&fd[i*4+3]<128){var pi=i*4;fd[pi]=255;fd[pi+1]=255;fd[pi+2]=255;fd[pi+3]=255;}}
    /* Horizontal scanline fill — ONLY in the lower 55% (text area) to bridge letter gaps */
    var sMinY=ch,sMaxY=0,sMinX=cw,sMaxX=0;
    for(var y=0;y<ch;y++)for(var x=0;x<cw;x++)if(fd[(y*cw+x)*4+3]>128){if(y<sMinY)sMinY=y;if(y>sMaxY)sMaxY=y;if(x<sMinX)sMinX=x;if(x>sMaxX)sMaxX=x;}
    var textTop=Math.floor(sMinY+(sMaxY-sMinY)*0.58);
    var maxGap=Math.min(Math.round(Math.max(pW,pH)*0.06),Math.round(Math.max(pW,pH)*0.04));
    var textBot=Math.floor(sMaxY-(sMaxY-sMinY)*0.15);
    for(var y=textTop;y<=textBot;y++){
      var left=-1,right=-1;
      for(var x=0;x<cw;x++)if(fd[(y*cw+x)*4+3]>128){left=x;break;}
      for(var x=cw-1;x>=0;x--)if(fd[(y*cw+x)*4+3]>128){right=x;break;}
      if(left<0||right<=left)continue;
      var inGap=false,gapStart=0;
      for(var x=left;x<=right;x++){
        var solid=fd[(y*cw+x)*4+3]>128;
        if(!solid&&!inGap){inGap=true;gapStart=x;}
        if(solid&&inGap){
          var gapW=x-gapStart;
          if(gapW<=maxGap)for(var gx=gapStart;gx<x;gx++){var pi=(y*cw+gx)*4;fd[pi]=255;fd[pi+1]=255;fd[pi+2]=255;fd[pi+3]=255;}
          inGap=false;
        }
      }
    }
    cx.putImageData(fillData,0,0);
    /* Smooth the white backing edge: downscale → upscale → threshold */
    var smSc=0.2;
    var smW=Math.max(1,Math.round(cw*smSc)),smH=Math.max(1,Math.round(ch*smSc));
    var smCv=document.createElement('canvas');smCv.width=smW;smCv.height=smH;
    var smCx=smCv.getContext('2d');
    smCx.imageSmoothingEnabled=true;smCx.imageSmoothingQuality='high';
    smCx.drawImage(cv,0,0,smW,smH);
    var upCv=document.createElement('canvas');upCv.width=cw;upCv.height=ch;
    var upCx=upCv.getContext('2d');
    upCx.imageSmoothingEnabled=true;upCx.imageSmoothingQuality='high';
    upCx.filter='blur(20px)';
    upCx.drawImage(smCv,0,0,cw,ch);
    upCx.filter='none';
    var upD=upCx.getImageData(0,0,cw,ch);
    var ud=upD.data;
    for(var i=0;i<ud.length;i+=4){ud[i]=255;ud[i+1]=255;ud[i+2]=255;ud[i+3]=ud[i+3]>=128?255:0;}
    upCx.putImageData(upD,0,0);
    /* Use smoothed backing for both display and trace */
    cx.globalCompositeOperation='source-over';
    cx.clearRect(0,0,cw,ch);
    cx.drawImage(upCv,0,0);
    /* Extract cutline: Moore trace on smoothed backing */
    var backData=cx.getImageData(0,0,cw,ch).data;
    var trM=new Uint8Array(cw*ch);for(var i=0;i<cw*ch;i++)trM[i]=backData[i*4+3]>128?1:0;
    var dirs=[[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1],[1,-1]];
    var sx2=-1,sy2=-1;
    for(var y=0;y<ch&&sx2<0;y++)for(var x=0;x<cw;x++)if(trM[y*cw+x]){sx2=x;sy2=y;break;}
    var cutPts=null;
    if(sx2>=0){
      var pts=[],cx2=sx2,cy2=sy2,dir=7,len=0;
      do{pts.push([(cx2-pad),(cy2-pad)]);var sd=(dir+6)%8,fn=false;
        for(var di=0;di<8;di++){var d2=(sd+di)%8,nx2=cx2+dirs[d2][0],ny2=cy2+dirs[d2][1];
          if(nx2>=0&&nx2<cw&&ny2>=0&&ny2<ch&&trM[ny2*cw+nx2]){cx2=nx2;cy2=ny2;dir=d2;fn=true;break;}}
        if(!fn)break;len++;
      }while((cx2!==sx2||cy2!==sy2)&&len<cw*ch);
      if(pts.length>10)cutPts=pts;
    }
    /* Scale cutPts to original coordinates */
    if(cutPts&&sc<1)for(var i=0;i<cutPts.length;i++){cutPts[i][0]/=sc;cutPts[i][1]/=sc;}
    if(sc<1){
      var oPad=Math.round(pad/sc),oCw=oW+oPad*2,oCh=oH+oPad*2;
      var oCv=document.createElement('canvas');oCv.width=oCw;oCv.height=oCh;
      var oCx=oCv.getContext('2d');oCx.imageSmoothingEnabled=true;oCx.imageSmoothingQuality='high';
      oCx.drawImage(cv,0,0,oCw,oCh);oCx.drawImage(img,oPad,oPad);
      return{canvas:oCv,width:oCw,height:oCh,offsetX:oPad,offsetY:oPad,cutPts:cutPts};
    }
    cx.globalCompositeOperation='source-over';
    cx.drawImage(img,pad,pad);
    return{canvas:cv,width:cw,height:ch,offsetX:pad,offsetY:pad,cutPts:cutPts};
  }catch(e){console.error('stickerBorder:',e);return null;}
};
})();
